import React, { useEffect, useState, useRef, Fragment } from "react";
import { Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import { MOBILE_DISPLAY, STATIC_URL } from "./../../../../constants";
import UeDataBullet from "./UeDataBullet";
import NumberFormat from "react-number-format";
import useIsMounted from "./../../../utilities/useIsMounted";

const GeoDataServitude = (props) => {
   const [isLoading, setIsLoading] = useState(false);
   const [asData, setAsData] = useState(false);
   const [items, setItems] = useState([]);
   const [items2, setItems2] = useState([]);
   const [detailView, setDetailView] = useState();
   const isMounted = useIsMounted();
   let urls = [];


   useEffect(() => {
      if (props.infoParcelle) {

         if (isMounted.current) {
            setItems(Object.entries(props.infoParcelle));
            setAsData(true);
            props.updateFormData("servitude", props.infoParcelle);
            props.updateFormData("servitude2", props.perimTerritoriaux);
         }

      } else {
         console.log("props.infoParcelle");
         props.updateFormData("servitude", []);
      }
      //fetchData();
   }, [props.keypars, props.infoParcelle]);

   useEffect(() => { }, [asData, items, items2]);

   useEffect(() => {
      items.length > 0 ? setAsData(true) : setAsData(false);
      Object.values(items).map((item, index) => {
         item.urlfic && item.urlfic !== ""
            ? urls.push({
               title: item.libelle_1,
               url: STATIC_URL + item.urlfic,
               urltype: "ext",
               section: "servitude",
               active: true,
            })
            : null;
         index === items.length - 1
            ? props.updateFormLinks("servitude", {
               id: index,
               section: "servitudes",
               subsection: null,
               order: 1,
               data: urls,
            })
            : null;
      });
   }, [items]);

   useEffect(() => {
      setDetailView(props.detailData);
   }, [props.detailData]);

   const fetchData = async () => {
      //setIsLoading(true);
      const params = {
         key_parcelles: props.keypars,
      };

      try {
         let result2 = await axios.post("/Api/geodata/stat/parcelle/perim_information/com", params);

         props.updateFormData("servitude2", result2.data);
         setIsLoading(false);
      } catch (err) {
         console.log(err);
         props.updateFormData("servitude2", []);
         setIsLoading(false);
      }
   };

   const renderItem = (item, index) => {
      return (
         <tr key={index}>
            <td>
               {item?.id_alea === 0 || item?.id_alea === 1 ? (
                  <UeDataBullet color={item.id_alea === 1 ? "var(--theme-danger)" : "var(--theme-secondary)"} />
               ) : (
                  <UeDataBullet color={"var(--theme-gray1)"} />
               )}
            </td>
            <td className={"text-center"}>
               {item.urlfic && item.urlfic !== "" ? (
                  <a
                     href={item.urlfic}
                     target="_blank"
                     data-toggle="tooltip"
                     data-placement="top"
                     title="Visualiser le document"
                     className="btn btn-sm"
                  >
                     <i
                        className="bi bi-arrow-down-circle"
                        style={{
                           fontSize: "16px",
                           color: "var(--theme-primary)",
                        }}
                     ></i>
                  </a>
               ) : (
                  <span style={{ color: "var(--theme_gray1" }}>
                     <i
                        className="bi bi-arrow-down-circle "
                        style={{
                           fontSize: "16px",
                           color: "var(--theme-light)",
                        }}
                     ></i>
                  </span>
               )}
            </td>
            <td>
               <div className={"ue-data-table-label-row"}>{item.libelle_1} </div>
            </td>
            <td style={{ verticalAlign: "middle", width: "110px" }}>
               <div className={"d-flex justify-content-around  h100"}>
                  <NumberFormat
                     className={"d-none d-md-block"}
                     displayType={"text"}
                     thousandSeparator={" "}
                     value={Math.round(item.pourcentage * 10) / 10}
                  />
                  {props.showSurface && (
                     <div style={{ whiteSpace: "nowrap" }}>
                        <NumberFormat
                           displayType={"text"}
                           thousandSeparator={" "}
                           value={Math.round(item.surface)}
                        />
                        <span className={"d-md-none"}>m</span>
                     </div>
                  )}
               </div>
            </td>
         </tr>
      );
   };

   const renderSubItem = (subitem, index) => {
      return (
         <div key={index} className={"d-flex flex-row justify-content-between"}>
            <div className={"ue-data-resum "} style={{ whiteSpace: "pre-warp" }}>
               {" "}
               {subitem.libelle_2}
            </div>
            <div className={"d-flex flex-row text-right px-2  h100"}>
               {props.showSurface && (
                  <div className={"my-1"} style={{ fontWeight: "700" }}>
                     {Math.round(subitem.surface)}m
                  </div>
               )}
               <div className={"my-1"} style={{ fontWeight: "700", marginLeft: "5px" }}>
                  ({Math.round(subitem.pourcentage * 10) / 10 + "%"})
               </div>
            </div>
         </div>
      );
   };
   const uniqueItems = Object.values(items).filter((value, index, self) => {
      return index === self.findIndex((t) => t.id_layer === value.id_layer);
   });
   return (
      <div id={"geodata_servitude"} className={asData ? "ueGeoDataSubpanel" : null}>
         {asData && items.length ? (
            <Fragment>
               <div id={"ue-geodata-section-block"} />
               <table className="table table-condensed ue-table-data">
                  <thead>
                     {props.windowsSize > MOBILE_DISPLAY ? (
                        <tr
                           style={{
                              paddindTop: "3px!important",
                              color: "#70979A",
                           }}
                        >
                           <th width={"2"}></th>
                           <th width={"2"} className={"text-center"}>
                              Pdf
                           </th>
                           <th style={{ fontSize: "12px" }}>SERVITUDES</th>
                           {props.showSurface ? (
                              <th
                                 className={"d-flex justify-content-between"}
                                 style={{ width: "110px", fontWeight: "400" }}
                              >

                                 <span>%</span>
                                 <span className={"font-weight-bold"}>Surface</span>
                                 <span>m</span>
                              </th>
                           ) : (
                              <th
                                 className={"d-flex justify-content-center"}
                                 style={{ width: "110px", fontWeight: "400" }}
                              >
                                 <span className={"font-weight-bold"}>Surface (%)</span>
                              </th>
                           )}
                        </tr>
                     ) : (
                        <tr
                           style={{
                              paddindTop: "3px!important",
                              color: "#70979A",
                           }}
                        >
                           <th width={"2"}></th>
                           <th width={"2"} className={"text-center"}>
                              Pdf
                           </th>
                           <th colSpan={2} className={"w-100"} style={{ fontSize: "12px" }}>
                              SERVITUDES
                           </th>
                        </tr>
                     )}
                     {/*<tr style={{'paddindTop':'3px!important'}}>
                                <th width={'2'}></th>
                                <th width={'2'} className={'text-center'}>Pdf</th>
                                {(props.windowsSize>MOBILE_DISPLAY)
                                    ?<fragment>
                                        <th >Servitudes d'Utilité Publique : </th>
                                        <th className={"d-flex justify-content-between"} style={{ width: '110px', fontWeight: '400'}}>
                                            <span>%</span><span className={'font-weight-bold'}>Surface</span><span>m<sup>2</sup></span>
                                        </th>
                                    </fragment>
                                    : <th colSpan={2} className={"w-100"}>Servitudes d'Utilité Publique :  </th>
                                }
                            </tr>*/}
                  </thead>
                  <tbody>
                     {items.map((item, index) => {
                        return renderItem(item[1], index);
                     })}
                  </tbody>
               </table>
            </Fragment>
         ) : isLoading ? (
            <div className="text-center my-2">
               <Spinner animation="border" size={"sm"} />
            </div>
         ) : (
            <table className="table table-condensed ue-table-data">
               <thead>
                  <tr
                     style={{
                        paddindTop: "3px!important",
                        color: "#70979A",
                     }}
                  >
                     <th width={"2"}></th>
                     <th width={"2"} className={"text-center"}>
                        Pdf
                     </th>
                     <th colSpan={2} className={"w-100"} style={{ fontSize: "12px" }}>
                        SERVITUDE D'UTILITE PUBLIQUE
                     </th>
                  </tr>
               </thead>
               <tbody>
                  <tr>
                     <td width={2}>
                        <UeDataBullet color={"var(--theme-light)"} />
                     </td>
                     <td className={"text-center"} width={2}>
                        <i
                           className="bi bi-arrow-down-circle "
                           style={{
                              fontSize: "16px",
                              color: "var(--theme-light)",
                           }}
                        ></i>
                     </td>
                     <td>Néant</td>
                  </tr>
               </tbody>
            </table>
         )}
      </div>
   );
};
const mapStateToProps = (state) => {
   return {
      detailData: state.LeftPanelReducer.showDetailData,
      windowsSize: state.AppReducer.windowsSize,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      updateFormData: (k, e) => dispatch({ type: "UPDATE_FORM_DATA", data: { key: k, data: e } }),
      updateFormLinks: (k, e) => dispatch({ type: "UPDATE_FORM_LINKS", data: { key: k, links: e } }),
   };
};
export default connect(mapStateToProps, mapDispatchTProps)(GeoDataServitude);
